import React, { ReactElement, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import {
  AccountingBackend,
  getStoredAccountingBackend,
  matchesAccountingBackendGate,
} from "../../../../config/accounting";
import { V1_HOME_PATH } from "../../../../layouts/v1/config/navigation";

interface RequireAccountingBackendProps {
  /** Backend this route is built for. */
  backend: AccountingBackend;
  children: ReactNode;
  /** Where mismatched tenants land. Defaults to the v1 home shell. */
  fallbackTo?: string;
}

/**
 * Route guard for Zoho-only or Tally-only screens.
 *
 * Hides the destination the same way the sidebar does: a typed URL should not
 * open a surface that only talks to the other books system.
 */
export const RequireAccountingBackend: React.FC<
  RequireAccountingBackendProps
> = ({ backend, children, fallbackTo = V1_HOME_PATH }): ReactElement => {
  if (!matchesAccountingBackendGate(backend, getStoredAccountingBackend())) {
    return <Navigate to={fallbackTo} replace />;
  }

  return <>{children}</>;
};
